import ShowHide from './show-hide';
import { document } from '../globals';

if (document) {
  ShowHide.bindToggles(document.body);
}
